import React from 'react';
import { FadeIn } from './FadeIn';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  label?: string;
  centered?: boolean;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  label,
  centered = true,
  light = false
}: SectionHeadingProps) {
  return <FadeIn className={`mb-12 md:mb-16 ${centered ? 'text-center' : ''}`} data-id="element-180">
      {label && <h4 className={`font-bold tracking-wider uppercase mb-3 ${light ? 'text-gold' : 'text-gold'}`} data-id="element-181">
          {label}
        </h4>}
      <h2 className={`text-3xl md:text-4xl font-extrabold mb-4 ${light ? 'text-white' : 'text-navy'}`} data-id="element-182">
        {title}
      </h2>
      <div className={`w-16 h-1 bg-gold rounded-full ${centered ? 'mx-auto' : ''} mb-6`} data-id="element-183"></div>
      {subtitle && <p className={`text-lg max-w-2xl ${centered ? 'mx-auto' : ''} ${light ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-184">
          {subtitle}
        </p>}
    </FadeIn>;
}